import { PageSettings } from '../../../shared/models/category-filter.model';

export class CategoryFilter extends PageSettings {
    CategorId: number;
}


